import { get } from 'lodash';

export const getPaymentType = payment => {
  if (hasToVerifyMicroDeposits(payment)) return 'bank_account';

  return get(payment, 'source.object', null);
};

export const hasPaymentToPublish = (payment, user) => {
  if (hasToVerifyMicroDeposits(payment)) return true;
  if (user.go4Paid) return true;

  return !!payment && !!payment.source && !!payment.source.id && !!payment.loadedSource;
};

export const hasToVerifyMicroDeposits = payment => {
  return !!Object.keys(payment).includes('publicToken') && !!payment.publicToken;
};

export const getErrorMessage = message => {
  return message.replace(/\(.*?\)/g, '').trim();
};

export const showBlockedFailedPaymentPopups = user => {
  if (user.go4Paid) return;

  return user.blockedFailedPaymentAt || user.updatedPaymentMethodAt;
};

export const hasPendingFailedPayment = job => {
  return job.lastPaymentAttemptAt && !get(job, 'payment.paidAt');
};

export const blockedByFailedPayment = user => {
  return user.blockedFailedPaymentAt && !user.failedPaymentBlockOverride && !user.go4Paid;
};

export const pendingUnblockFailedPayment = user => {
  return user.updatedPaymentMethodAt && !user.failedPaymentBlockOverride && !user.go4Paid;
};

// Whether the ACH authorization has been given for the payment method being
// saved. `stripeTerms` is consent captured in this session's mandate modal;
// `mandateAcceptedOn` is consent already on file from a previous session or from
// accepting the updated Terms. Either satisfies saving — without the persisted
// half, a user who consented earlier (e.g. before a micro-deposit wait) comes
// back to a permanently disabled Update Payment button.
export const hasAchMandateConsent = ({ user, stripeTerms } = {}) => {
  return !!stripeTerms || !!(user || {}).mandateAcceptedOn;
};

export const ACH_MANDATE_CONSENT_TEXT_PREFIX =
  'By saving your bank account credentials, you authorize Go4 and its payment processor to electronically debit your account and, if necessary, electronically credit your account to correct erroneous debits related to amounts owed in connection with Services you request. Payments may be initiated after Services have been completed and applicable fees have been calculated. This authorization will remain in effect for future payments unless revoked by contacting us at ';

export const ACH_MANDATE_CONSENT_TEXT_SUFFIX = '.';
